export default "__VITE_ASSET__xJpwtNBJ__"